import { createContext, useContext } from 'react'
import { AuthContextType } from '../types/auth'

export const AuthContext = createContext<AuthContextType | null>(null)

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export function useRequireAuth() {
  const auth = useAuth()
  if (!auth.isAuthenticated) {
    throw new Error('User must be authenticated')
  }
  return auth
}